<template>
  <div>
    <el-form label-width="120px" label-position="right">
      <el-form-item label="商户id：">
        <el-input v-model="fee_data.mch_no" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="费用编号：">
        <el-input
          :disabled="formtype == 'update' ? true : false"
          v-model="fee_data.free_no"
          :placeholder="
            formtype == 'update'
              ? '费用编号不可以修改'
              : '填写费用编号，不可以重复'
          "
        ></el-input>
      </el-form-item>
      <el-form-item label="费用名称：">
        <el-input
          v-model="fee_data.free_name"
          placeholder="填写费用名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="费用类型：">
        <el-select v-model="fee_data.free_type" placeholder="选择费用类型">
          <el-option
            v-for="item in fee_options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态：" v-if="formtype == 'update'">
        <el-radio v-model="fee_data.flag" label="1">启用</el-radio>
        <el-radio v-model="fee_data.flag" label="0">禁用</el-radio>
      </el-form-item>
      <el-form-item label="详细说明："
        ><el-input
          type="textarea"
          v-model="fee_data.other1"
          :rows="4"
          style="width:300px"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button v-if="formtype == 'create'">新建</el-button>
        <el-button v-if="formtype == 'create'" type="primary" @click="createFee"
          >保存</el-button
        >
        <el-button v-if="formtype == 'update'" type="primary" @click="updateFee"
          >保存</el-button
        ><el-button
          v-if="formtype == 'create'"
          type="warning"
          @click="showDialog"
          >导入费用模板</el-button
        >
      </el-form-item>
    </el-form>
    <el-dialog title="费用模板" :visible.sync="DialogVisible" width="600px">
      <el-table
        :data="fee_template"
        :max-height="300"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          property="free_name"
          label="费用名称"
          width="150"
        ></el-table-column>
        <el-table-column
          property="free_typename"
          label="费用类型"
          width="100"
        ></el-table-column>
        <el-table-column
          property="other1"
          width="200"
          label="费用说明"
        ></el-table-column>
      </el-table>
      <div class="import-btn-fa">
        <el-button type="success" @click="ImportFeeTemplate">导入</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  FreeDir,
  FreeCreate,
  FreeModidy,
  FreeTemplate
} from "@/api/index";
export default {
  name: "freeForm",
  inject: ["reload"],
  data() {
    return {
      fee_data: {
        access_token: localStorage.getItem("access_token"),
        mch_no: localStorage.getItem("mch_id"),
        free_no: "",
        free_name: "",
        free_type: 0,
        other1: "",
        flag: "1"
      },
      fee_options: [
        {
          value: 0,
          label: "收取一次"
        },
        {
          value: 1,
          label: "按月收取"
        },
        {
          value: 2,
          label: "按季度收取"
        },
        {
          value: 3,
          label: "按半年收取"
        },
        {
          value: 4,
          label: "按年收取"
        }
      ],
      //选中导入的模板
      checked_list: [],
      template: "",
      fee_template: [],
      DialogVisible: false
    };
  },
  props: {
    formtype: String
  },
  mounted() {},
  methods: {
    async createFee() {
      const res = await FreeCreate(this.fee_data);
      console.log(res);
    },
    async updateFee(feeData) {
      if (feeData) {
        this.fee_data = feeData;
      }
      const res = await FreeModidy(this.feeData);
      console.log(res);
    },
    async showDialog() {
      const res = await FreeTemplate();
      if (
        res.data.result_code === "SUCCESS" &&
        res.data.return_code === "SUCCESS"
      ) {
        this.fee_template = res.data.resp_data;
        for (let i = 0; i < this.fee_template.length; i++) {
          if (this.fee_template[i].free_type === "0") {
            this.fee_template[i].free_typename = "一次收取";
          } else if (this.fee_template[i].free_type === "1") {
            this.fee_template[i].free_typename = "按月收取";
          } else if (this.fee_template[i].free_type === "2") {
            this.fee_template[i].free_typename = "按季度收取";
          } else if (this.fee_template[i].free_type === "3") {
            this.fee_template[i].free_typename = "按半年收取";
          } else if (this.fee_template[i].free_type === "4") {
            this.fee_template[i].free_typename = "按年收取";
          }
        }
      } else if (res.data.result_code === "FAIL" && res.data.result_msg) {
        this.warnMessage(res.data.result_msg);
      } else if (res.data.return_code === "FAIL" && res.data.return_msg) {
        this.warnMessage(res.data.return_msg);
      }
      console.log(this.fee_template)
      this.DialogVisible = true;
    },
    handleSelectionChange(list) {
      this.checked_list = list;
    },
    async ImportFeeTemplate() {
      // eslint-disable-next-line eqeqeq
      if (this.checked_list.length === 0 || this.checked_list == []) {
        this.warnMessage("请选择模板");
      } else {
        const res = await FreeDir({
          access_token: localStorage.getItem("access_token"),
          mch_no: localStorage.getItem("mch_id")
        });
        console.log("获取所有付款项", res.data.resp_data);
        // for()
      }
    }
  }
};
</script>
<style scoped>
.el-form {
  color: #9d9fa5;
}
#date-div >>> .el-input {
  width: 200px !important;
}
.el-form-item >>> .el-input {
  width: 300px !important;
}
/* .el-divider--horizontal {
  height: 0.1px;
  margin-top: 5px !important;
  margin-right: 30px !important;
  margin-bottom: 0 !important;
} */
.body-right-bottom {
  width: 100%;
  position: absolute;
  bottom: 10px;
  display: flex;
  justify-content: center;
}
.import-btn-fa {
  width: 100%;
  /* padding: 10px 0 0 0; */
  margin-top: 10px;
  /* background-color: pink; */
}
</style>
